import { render } from "./RegisterSmall.vue?vue&type=template&id=272a5796&ts=true"
import script from "./RegisterSmall.vue?vue&type=script&lang=ts"
export * from "./RegisterSmall.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\Administrator\\Documents\\Repos\\PROD-license-management\\redesign\\WebUI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__